import { FC } from 'react';

import { Regular } from '@zazume/zzm-base';

import { BasicUserFieldSkeleton } from '#/components/skeleton/atoms/BasicUserFieldSkeleton';
import { DetailPageSkeleton } from '#/components/skeleton/atoms/DetailPageSkeleton';
import { TableSkeleton } from '#/components/skeleton/atoms/TableSkeleton';

type SkeletonProps = FC & {
  Table: typeof TableSkeleton;
  BasicUserField: typeof BasicUserFieldSkeleton;
  DetailPage: typeof DetailPageSkeleton;
};

export const Skeleton: SkeletonProps = () => {
  return (
    <>
      <Regular.Skeleton />
    </>
  );
};

Skeleton.Table = TableSkeleton;
Skeleton.BasicUserField = BasicUserFieldSkeleton;
Skeleton.DetailPage = DetailPageSkeleton;
